module.exports = __webpack_public_path__ + "img/6.ba00353f.jpg";